import { Flex } from '@zeal/web-ui';
import styled from 'styled-components';

export const NotificationsContainer = styled(Flex)`
	height: 460px;
	border-bottom-right-radius: 0.5rem /* 8px */;
	border-bottom-left-radius: 0.5rem /* 8px */;
	overflow-x: hidden;
	overflow-y: hidden;

	* {
		/* width */
		::-webkit-scrollbar {
			width: 16px;
			background: rgba(241, 242, 243, 1);
		}

		/* Track */
		::-webkit-scrollbar-track {
			width: 16px;
			background: rgba(241, 242, 243, 1);
		}

		/* Handle */
		::-webkit-scrollbar-thumb {
			width: 6px;
			background: #d2d5d8;
			border: 4px solid rgba(241, 242, 243, 1);
		}
	}
`;
